import type * as React from 'react';
import {cva, type VariantProps} from 'class-variance-authority';

import {cn} from '@/modules/foundation/shared/tailwind';

const badgeVariants = cva(
	[
		'focus:ring-ring',
		'inline-flex',
		'items-center',
		'rounded-full',
		'border',
		'px-3',
		'py-1',
		'text-xs',
		'font-normal',
		'transition-colors',
		'focus:outline-hidden',
		'focus:ring-2',
		'focus:ring-offset-2',
	],
	{
		variants: {
			variant: {
				default:
					'border-transparent bg-primary text-primary-foreground shadow-sm hover:bg-primary/80',
				secondary:
					'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
				destructive:
					'bg-destructive text-destructive-foreground hover:bg-destructive/80 border-transparent shadow-sm',
				outline: 'border-secondary-40 text-primary-5',
			},
		},
		defaultVariants: {
			variant: 'default',
		},
	},
);

export interface BadgeProps
	extends
		React.HTMLAttributes<HTMLDivElement>,
		VariantProps<typeof badgeVariants> {}

function Badge({className, variant, ...props}: BadgeProps) {
	return (
		<span className={cn(badgeVariants({variant}), className)} {...props} />
	);
}

export {Badge, badgeVariants};
